import { Icon } from '@iconify/react'
import { WinnersSectionCard } from '@/components/WinnersSectionCard'
import { WinnerLookupPanel } from '@/components/WinnerLookupPanel'
import { WinnerRankingPanel } from '@/components/WinnerRankingPanel'
import sectionStyles from './WinnersPageSections.module.css'

export interface SorteioWinnersSectionProps {
  campaignId: number | null
  isLoading: boolean
  hasCampaigns: boolean
}

export function SorteioWinnersSection({
  campaignId,
  isLoading,
  hasCampaigns,
}: SorteioWinnersSectionProps) {
  return (
    <WinnersSectionCard
      id="winners-sorteio-section"
      title="Ganhadores do sorteio"
      subtitle="Ranking por período e busca da cota vencedora na Loteria Federal."
      icon="mdi:ticket-confirmation-outline"
    >
      {isLoading ? (
        <div className={sectionStyles.centered}>
          <Icon icon="mdi:loading" className={sectionStyles.spinner} />
          Carregando campanha de sorteio...
        </div>
      ) : !hasCampaigns ? (
        <p className={sectionStyles.emptyMessage}>
          Nenhuma campanha de sorteio cadastrada. Crie uma campanha para consultar ganhadores.
        </p>
      ) : campaignId == null ? (
        <p className={sectionStyles.emptyMessage}>
          Selecione uma campanha de sorteio no topo da página.
        </p>
      ) : (
        <div className={sectionStyles.stack}>
          <WinnerRankingPanel campaignId={campaignId} />
          <WinnerLookupPanel campaignId={campaignId} />
        </div>
      )}
    </WinnersSectionCard>
  )
}
